import { diagnosticsApi, type DxNamedMasterDto } from "@/api/diagnostics";
import { MasterListPage } from "./MasterListPage";
import { MasterFormPage } from "./MasterFormPage";
import { statusColumn, TextFieldCell, SwitchCell } from "./fields";

const BASE = "/diagnostics/specimens";
const LIST_KEY = ["dx-specimens"];

export function DiagnosticsSpecimensPage() {
  return (
    <MasterListPage<DxNamedMasterDto>
      breadcrumbs={["Diagnostics", "Masters"]}
      title="Specimens"
      subtitle="Sample types drawn for lab tests (blood, urine, stool…)."
      queryKey={LIST_KEY}
      listFn={(inc) => diagnosticsApi.listSpecimens(inc)}
      deleteFn={diagnosticsApi.deleteSpecimen}
      basePath={BASE}
      newLabel="New specimen"
      labelOf={(r) => r.name}
      deleteNote="It will be refused if any lab test defaults to it or any collected sample refers to it."
      columns={[
        { field: "code", headerName: "Code", width: 160 },
        { field: "name", headerName: "Name", flex: 1, minWidth: 240 },
        statusColumn<DxNamedMasterDto>(),
      ]}
    />
  );
}

interface Values { code: string; name: string; isActive: boolean }

export function SpecimenFormPage() {
  return (
    <MasterFormPage<Values, DxNamedMasterDto>
      breadcrumbs={["Diagnostics", "Specimens"]}
      noun="specimen"
      basePath={BASE}
      listQueryKey={LIST_KEY}
      detailQueryKey={(id) => ["dx-specimen", id]}
      defaultValues={{ code: "", name: "", isActive: true }}
      getFn={diagnosticsApi.getSpecimen}
      toValues={(d) => ({ code: d.code, name: d.name, isActive: d.isActive })}
      createFn={(v) => diagnosticsApi.createSpecimen({ code: v.code.trim(), name: v.name.trim() })}
      updateFn={(id, v) => diagnosticsApi.updateSpecimen(id, { code: v.code.trim(), name: v.name.trim(), isActive: v.isActive })}
    >
      {({ control }, isEdit) => (
        <>
          <TextFieldCell control={control} name="code" label="Code" span={4} required />
          <TextFieldCell control={control} name="name" label="Name" span={8} required />
          {isEdit && <SwitchCell control={control} name="isActive" label="Active" />}
        </>
      )}
    </MasterFormPage>
  );
}
